import { useState, useEffect } from "react";
import { throttle, debounce } from "lodash";

const useTabVisibility = () => {
  const [isTabActive, setIsTabActive] = useState(true);

  useEffect(() => {
    // Throttle to ensure "active" is called at most every 8 seconds
    const markActive = throttle(() => {
      setIsTabActive(true);
    }, 8000);

    // Debounce to set "inactive" after 10 seconds of no activity
    const markInactive = debounce(() => {
      setIsTabActive(false);
    }, 10000);

    const handleUserActivity = () => {
      markActive(); // Mark as active (throttled)
      markInactive(); // Reset inactivity timer (debounced)
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        setIsTabActive(false);
      } else {
        setIsTabActive(true);
      }
    }
    // Listen for user activity
    const events = ["keydown", "mousedown"];
    events.forEach(event => window.addEventListener(event, handleUserActivity));
    window.addEventListener("visibilitychange", handleVisibilityChange);
    // Cleanup event listeners on unmount
    return () => {
      events.forEach(event => window.removeEventListener(event, handleUserActivity));
      window.removeEventListener("visibilitychange", handleVisibilityChange);
      markActive.cancel(); // Cancel throttled calls
      markInactive.cancel(); // Cancel debounced calls
    };
  }, []);

  return isTabActive;
};

export default useTabVisibility;